import { useTranslation } from 'react-i18next'

import { LightningIcon } from '@phosphor-icons/react'

import { Text } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'

import InstantExchangeOrdersAutomaticCreationSelector from './InstantExchangeOrdersAutomaticCreationSelector/InstantExchangeOrdersAutomaticCreationSelector'
import InstantExchangeSendProviderNotificationCheckbox from './InstantExchangeSendProviderNotificationCheckbox/InstantExchangeSendProviderNotificationCheckbox'
import * as Styles from './styles'

const InstantExchangesConfiguration = ({
  allowInstantExchanges,
  allowedPreferences,
  instantExchangeOrdersAutomaticCreation,
  setInstantExchangeOrdersAutomaticCreation,
  instantExchangeOrdersSendProviderNotification,
  setInstantExchangeOrdersSendProviderNotification,
  provider,
  disabled,
  instantExchangePaymentExpiration,
  setInstantExchangePaymentExpiration,
}) => {
  const { t } = useTranslation()

  if (!allowedPreferences.includes(preferences.allowsInstantExchanges) || !allowInstantExchanges) return null

  return (
    <Styles.Container>
      <Styles.Title type="bodyMBold">
        <LightningIcon size={24} weight="fill" />
        {t('Cambios instantáneos')}
      </Styles.Title>
      <Text type="bodyMRegular">
        {t(
          'Los clientes elegibles podrán recibir cambios instantáneos, sin esperar a devolver sus viejos productos (Con cobertura Reveni)'
        )}
      </Text>
      <InstantExchangeOrdersAutomaticCreationSelector
        allowedPreferences={allowedPreferences}
        instantExchangeOrdersAutomaticCreation={instantExchangeOrdersAutomaticCreation}
        setInstantExchangeOrdersAutomaticCreation={setInstantExchangeOrdersAutomaticCreation}
        disabled={disabled}
        instantExchangePaymentExpiration={instantExchangePaymentExpiration}
        setInstantExchangePaymentExpiration={setInstantExchangePaymentExpiration}
      />
      <InstantExchangeSendProviderNotificationCheckbox
        allowedPreferences={allowedPreferences}
        instantExchangeOrdersAutomaticCreation={instantExchangeOrdersAutomaticCreation}
        checked={instantExchangeOrdersSendProviderNotification}
        onChange={setInstantExchangeOrdersSendProviderNotification}
        provider={provider}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default InstantExchangesConfiguration
